module.exports = __webpack_public_path__ + "static/media/Muddled.40ade4aa.png";